// really trigger hosting again again
import 'antd/dist/antd.css';
import './main.scss';
import compareVersions from 'compare-versions';
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { TUserId } from './PartyClientResponse';
import * as linkify from 'linkifyjs';
import { APP_VERSION, SETTING_MIN_APP_VERSION } from './components/party/AppConstants';
import { getVersion } from './controller/client/PartyClient';
import { onInvitesUpdate, onSettingsUpdate } from './controller/PartyDB';
import { useFunctionsEmulatorOnLocal } from './firebase/firebase';
import { AppActions, AppMapProps, IAppState, IReduxActions, setInvites } from './redux/reducer';
import Routes from './Routes';
import { AppStateProvider, useAppState } from './state/AppState';
import { GameStateProvider } from './components/game/GameState';

linkify.registerCustomProtocol('rtmp');

const App = ({ debug, toggleDebug }: IAppState & IReduxActions) => {
  useFunctionsEmulatorOnLocal();
  const [apiVersion, setApiVersion] = useState('');

  const { user } = useAppState();

  // Update invites
  useEffect(() => {
    if (!user) {
      return;
    }
    return onInvitesUpdate(user.uid as TUserId, (invites) => {
      setInvites(invites);
    });
  }, [user]);

  // Used to force client updates by setting min version in the DB
  useEffect(() => {
    return onSettingsUpdate(SETTING_MIN_APP_VERSION, (minAppVersion) => {
      if (minAppVersion && compareVersions(minAppVersion, APP_VERSION) > 0) {
        window.location.reload(false);
      }
    });
  }, []);

  // App maintenance
  useEffect(() => {
    const onKeydown = (event: KeyboardEvent) => {
      if ((event.ctrlKey && event.key === 'd') || (event.ctrlKey && event.key === 'j')) {
        toggleDebug();
      }
    };
    document.addEventListener('keydown', onKeydown);

    if (!apiVersion) {
      getVersion().then((version) => setApiVersion(version));
    }

    return () => {
      document.removeEventListener('keydown', onKeydown);
    };
  }, [user, apiVersion, toggleDebug]);

  return (
    <div className={`main ${debug ? 'debug' : ''}`} id='app'>
      <AppStateProvider>
        <GameStateProvider>
          <Routes />
        </GameStateProvider>
      </AppStateProvider>
    </div>
  );
};

export default connect(AppMapProps, AppActions)(App);
